import { useEffect, useState } from "react";

type ImagePreviewThumbProps = {
    file: File | null;
    url: string | null;
    alt: string;
    className?: string;
};

export default function ImagePreviewThumb({
    file,
    url,
    alt,
    className = "h-7 w-7",
}: ImagePreviewThumbProps) {
    const [objectUrl, setObjectUrl] = useState<string | null>(null);

    useEffect(() => {
        if (!file) {
            setObjectUrl(null);
            return;
        }

        const nextObjectUrl = URL.createObjectURL(file);
        setObjectUrl(nextObjectUrl);
        return () => URL.revokeObjectURL(nextObjectUrl);
    }, [file]);

    const src = objectUrl ?? url;
    if (!src) return null;

    return (
        <img
            src={src}
            alt={alt}
            className={`${className} rounded border border-[#d9d9d9] bg-white object-cover`}
        />
    );
}
